
export const Endpoints = {
    "getteacher": "https://api.makodesk.com/teacher/",
    "getteachers": "https://api.makodesk.com/teachers/",
    "subs": "https://api.makodesk.com/substitutes/",
    "subsbasicinfo": "https://api.makodesk.com/substitutes/basicinfo/",
    "createteacher": "https://api.makodesk.com/substitutes/",
    "getsublist": "https://api.makodesk.com/groups/Math%20Substitutes/phones",
    "getsubsbygroup": "https://api.makodesk.com/groups/",
    "getavailablesubs": "https://api.makodesk.com/substitutes/available",
    "createsubgroup": "https://api.makodesk.com/groups/",
    "getsubjob": "https://api.makodesk.com/sub-jobs/",
    "getinvitations": "https://api.makodesk.com/invitations/job/",
    "getmysubjobs": "https://api.makodesk.com/sub-jobs/myjobs/",
    "getteachersubjobs": "https://api.makodesk.com/sub-jobs/teacherjobsrequested/",
    "acceptsubjob": "https://api.makodesk.com/sub-jobs/acceptjob/",
    "cancelsubjob": "https://api.makodesk.com/sub-jobs/canceljob/",
    "createsubgroupmembership": "https://api.makodesk.com/group-memberships/",
    "getsubgroups": "https://api.makodesk.com/groups/groups/details",
    "getsubgroupfordropdown": "https://api.makodesk.com/groups/details",
    "getdepartmentsfordropdown": "https://api.makodesk.com/departments",
    "sendmessages": "https://api.makodesk.com/messaging/getsubs",
    "messageandcreatejob": "https://api.makodesk.com/messaging/subsandjob",
    "onboardingdocuments": "http://www.makodesk.com:8000/onboardingdocuments/",
    "auth": "http://www.makodesk.com:8000/auth",
    "upload": "http://www.makodesk.com:8000/upload",
    "s3BaseUrl": "https://apeshare.s3.us-west-2.amazonaws.com/",
    "teacherratings": "http://www.makodesk.com:8000/teacherratings/",
    "createteacherrating": "http://www.makodesk.com:8000/createteacherrating/"
};

export const Endpoints_local = {
    "getteacher": "http://localhost:8081/teacher/",
    "getteachers": "http://localhost:8081/teachers/",
    "subs": "http://localhost:8081/substitutes/",
    "subsbasicinfo": "http://localhost:8081/substitutes/basicinfo/",
    "createteacher": "http://localhost:8081/substitutes/",
    "getsublist": "http://localhost:8081/groups/Math%20Substitutes/phones",
    "getsubsbygroup": "http://localhost:8081/groups/",
    "getavailablesubs": "http://localhost:8081/substitutes/available",
    "createsubgroup": "http://localhost:8081/groups/",
    "getsubjob": "http://localhost:8081/sub-jobs/",
    "getinvitations": "http://localhost:8081/invitations/job/",
    "getmysubjobs": "http://localhost:8081/sub-jobs/myjobs/",
    "getteachersubjobs": "http://localhost:8081/sub-jobs/teacherjobsrequested/",
    "acceptsubjob": "http://localhost:8081/sub-jobs/acceptjob/",
    "cancelsubjob": "http://localhost:8081/sub-jobs/canceljob/",
    "createsubgroupmembership": "http://localhost:8081/group-memberships/",
    "getsubgroups": "http://localhost:8081/groups/groups/details",
    "getsubgroupfordropdown": "http://localhost:8081/groups/details",
    "getdepartmentsfordropdown": "http://localhost:8081/departments",
    "sendmessages": "http://localhost:8081/messaging/getsubs",
    "messageandcreatejob": "http://localhost:8081/messaging/subsandjob",
    "onboardingdocuments": "http://www.makodesk.com:8000/onboardingdocuments/",
    "auth": "http://www.makodesk.com:8000/auth",
    "upload": "http://www.makodesk.com:8000/upload",
    "s3BaseUrl": "https://apeshare.s3.us-west-2.amazonaws.com/",
    "teacherratings": "http://www.makodesk.com:8000/teacherratings/",
    "createteacherrating": "http://www.makodesk.com:8000/createteacherrating/"
};

export const EndpointsMakoDesk = {
    "getteacher": "http://www.makodesk.com:8000/teacher/",
    "getteachers": "http://www.makodesk.com:8000/teachers/",
    "createteacher": "http://www.makodesk.com:8000/createteacher/",
    "onboardingdocuments": "http://www.makodesk.com:8000/onboardingdocuments/",
    "auth": "http://www.makodesk.com:8000/auth",
    "upload": "http://www.makodesk.com:8000/upload",
    "s3BaseUrl": "https://apeshare.s3.us-west-2.amazonaws.com/",
    "teacherratings": "http://www.makodesk.com:8000/teacherratings/",
    "createteacherrating": "http://www.makodesk.com:8000/createteacherrating/"
};

export const EndpointsEC2 = {
    "getteacher": "http://ec2-35-162-157-248.us-west-2.compute.amazonaws.com:8000/teacher/",
    "getteachers": "http://ec2-35-162-157-248.us-west-2.compute.amazonaws.com:8000/teachers/",
    "createteacher": "http://ec2-35-162-157-248.us-west-2.compute.amazonaws.com:8000/createteacher/",
    "onboardingdocuments": "http://ec2-35-162-157-248.us-west-2.compute.amazonaws.com:8000/onboardingdocuments/",
    "auth": "http://ec2-35-162-157-248.us-west-2.compute.amazonaws.com:8000/auth",
    "upload": "http://ec2-35-162-157-248.us-west-2.compute.amazonaws.com:8000/upload",
    "s3BaseUrl": "https://apeshare.s3.us-west-2.amazonaws.com/",
    "teacherratings": "http://ec2-35-162-157-248.us-west-2.compute.amazonaws.com:8000/teacherratings/",
    "createteacherrating": "http://ec2-35-162-157-248.us-west-2.compute.amazonaws.com:8000/createteacherrating/"
};


